import React, { FC, useCallback, useState } from 'react';
import Header from 'components/header/Header.container';
import Footer from 'components/footer/Footer';
import ChatRoomPanel from 'components/chatRoomPanel/ChatRoomPanel';
import Styles from './ChatRoomPage.module.scss';

const ChatRoomPage: FC = () => {
  const [createRoomPopup, setCreateRoomPopup] = useState(false);

  const handleCreateRoom = useCallback(() => {
    setCreateRoomPopup(false);
    requestAnimationFrame(() => setCreateRoomPopup(true));
  }, []);

  return (
    <div className={Styles.wrapper}>
      <Header showPopup={createRoomPopup} hideOnPhone />
      <div className={Styles.main}>
        <div className="custom-container">
          <div className={Styles.chatRoomLayout}>
            <ChatRoomPanel fullPage onCreateRoom={handleCreateRoom} showAppNav />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ChatRoomPage;
